import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "PodScribe.IO: AI-Powered Content Repurposing for Creators",
  description = "Instantly repurpose your audio and video. PodScribe.IO uses AI to transform your content into high-quality show notes, blog posts, and social media content. Amplify your reach and save hours of work.",
  type = "website",
  name = "PodScribe.IO",
  url = "https://podscribe.io/",
  image = "https://podscribe.io/og-image.jpg",
  keyword = "AI Content Repurposing, Podcast to Blog, Video to Text, Content Repurposing Tool, AI for Creators, Podcast Show Notes, Social Media Content Generation, Content Workflow Automation",
}) {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content={name} />
      <meta name="keywords" content={keyword} />

      {/* OpenGraph tags */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional tags */}
      <meta name="apple-mobile-web-app-title" content={name} />
      <meta name="application-name" content={name} />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  );
}
